/*
This file exports three objects, one for each Material button variant (contained, outlined and text)
The exports are used by index.ts and not exported by ui-components package
*/

import { BLUE, GREEN, RED, GRAY, WHITE, AMBER, VIOLET } from "./hex";
var Contained = {
  primary: {
    main: {
      typography: WHITE,
      border: WHITE,
      background: BLUE[10]
    },
    hover: {
      typography: WHITE,
      border: WHITE,
      background: BLUE[11]
    },
    focus: {
      typography: WHITE,
      border: WHITE,
      background: BLUE[10]
    },
    active: {
      typography: BLUE[21],
      border: BLUE[21],
      background: BLUE[9]
    },
    disabled: {
      typography: GRAY[21],
      border: GRAY[21],
      background: GRAY[15]
    }
  },
  secondary: {
    main: {
      typography: WHITE,
      border: WHITE,
      background: GRAY[10]
    },
    hover: {
      typography: WHITE,
      border: WHITE,
      background: GRAY[11]
    },
    focus: {
      typography: WHITE,
      border: WHITE,
      background: GRAY[10]
    },
    active: {
      typography: GRAY[21],
      border: GRAY[21],
      background: GRAY[9]
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: GRAY[21]
    }
  },
  positive: {
    main: {
      typography: GREEN[5],
      border: GREEN[5],
      background: GREEN[15]
    },
    hover: {
      typography: GREEN[6],
      border: GREEN[6],
      background: GREEN[16]
    },
    focus: {
      typography: GREEN[5],
      border: GREEN[5],
      background: GREEN[15]
    },
    active: {
      typography: GREEN[4],
      border: GREEN[4],
      background: GREEN[14]
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: GRAY[21]
    }
  },
  negative: {
    main: {
      typography: WHITE,
      border: WHITE,
      background: RED[11]
    },
    hover: {
      typography: WHITE,
      border: WHITE,
      background: RED[12]
    },
    focus: {
      typography: WHITE,
      border: WHITE,
      background: RED[11]
    },
    active: {
      typography: RED[21],
      border: RED[21],
      background: RED[10]
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: GRAY[21]
    }
  },
  warning: {
    main: {
      typography: AMBER[5],
      border: AMBER[5],
      background: AMBER[17]
    },
    hover: {
      typography: AMBER[6],
      border: AMBER[6],
      background: AMBER[18]
    },
    focus: {
      typography: AMBER[5],
      border: AMBER[5],
      background: AMBER[17]
    },
    active: {
      typography: AMBER[4],
      border: AMBER[4],
      background: AMBER[16]
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: GRAY[21]
    }
  },
  lightPrimary: {
    main: {
      typography: BLUE[5],
      border: BLUE[10],
      background: BLUE[19]
    },
    hover: {
      typography: BLUE[5],
      border: BLUE[10],
      background: BLUE[19]
    },
    focus: {
      typography: WHITE,
      border: BLUE[10],
      background: BLUE[19]
    },
    active: {
      typography: BLUE[21],
      border: BLUE[10],
      background: BLUE[10]
    },
    disabled: {
      typography: GRAY[21],
      border: GRAY[21],
      background: GRAY[15]
    }
  }
};
var OutlinedAndText = {
  blueHover: {
    main: {
      /** Color Name: gray-5 */
      typography: GRAY[5],
      /** Color Name: gray-15 */
      border: GRAY[15],
      /** Color Name: gray-21 */
      background: GRAY[21]
    },
    hover: {
      /** Color Name: blue-5 */
      typography: BLUE[5],
      /** Color Name: blue-10 */
      border: BLUE[10],
      /** Color Name: blue-19 */
      background: BLUE[19]
    },
    focus: {
      /** Color Name: gray-5 */
      typography: GRAY[5],
      /** Color Name: gray-15 */
      border: GRAY[15],
      /** Color Name: gray-21 */
      background: GRAY[21]
    },
    active: {
      /** Color Name: gray-5 */
      typography: GRAY[5],
      /** Color Name: gray-15 */
      border: GRAY[15],
      /** Color Name: gray-21 */
      background: GRAY[21]
    },
    disabled: {
      /** Color Name: gray-5 */
      typography: GRAY[5],
      /** Color Name: gray-15 */
      border: GRAY[15],
      /** Color Name: gray-21 */
      background: GRAY[21]
    }
  },
  primary: {
    main: {
      typography: BLUE[10],
      border: BLUE[10],
      background: 'transparent'
    },
    hover: {
      typography: BLUE[11],
      border: BLUE[11],
      background: BLUE[19]
    },
    focus: {
      typography: BLUE[10],
      border: BLUE[10],
      background: 'transparent'
    },
    active: {
      typography: BLUE[9],
      border: BLUE[9],
      background: 'transparent'
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: 'transparent'
    }
  },
  secondary: {
    main: {
      typography: GRAY[5],
      border: GRAY[15],
      background: 'transparent'
    },
    hover: {
      typography: GRAY[6],
      border: GRAY[16],
      background: GRAY[19]
    },
    focus: {
      typography: GRAY[5],
      border: GRAY[15],
      background: 'transparent'
    },
    active: {
      typography: GRAY[6],
      border: GRAY[16],
      background: 'transparent'
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: 'transparent'
    }
  },
  positive: {
    main: {
      typography: GREEN[11],
      border: GREEN[11],
      background: 'transparent'
    },
    hover: {
      typography: GREEN[12],
      border: GREEN[12],
      background: 'transparent'
    },
    focus: {
      typography: GREEN[11],
      border: GREEN[11],
      background: 'transparent'
    },
    active: {
      typography: GREEN[10],
      border: GREEN[10],
      background: 'transparent'
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: 'transparent'
    }
  },
  negative: {
    main: {
      typography: RED[9],
      border: RED[9],
      background: 'transparent'
    },
    hover: {
      typography: RED[10],
      border: RED[10],
      background: RED[19]
    },
    focus: {
      typography: RED[9],
      border: RED[9],
      background: 'transparent'
    },
    active: {
      typography: RED[8],
      border: RED[8],
      background: 'transparent'
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: 'transparent'
    }
  },
  warning: {
    main: {
      typography: AMBER[12],
      border: AMBER[12],
      background: 'transparent'
    },
    hover: {
      typography: AMBER[13],
      border: AMBER[13],
      background: AMBER[19]
    },
    focus: {
      typography: AMBER[12],
      border: AMBER[12],
      background: 'transparent'
    },
    active: {
      typography: AMBER[11],
      border: AMBER[11],
      background: 'transparent'
    },
    disabled: {
      typography: GRAY[15],
      border: GRAY[15],
      background: 'transparent'
    }
  },
  magic: {
    main: {
      typography: VIOLET[12],
      border: VIOLET[12],
      background: 'transparent'
    },
    hover: {
      typography: VIOLET[13],
      border: VIOLET[13],
      background: 'transparent'
    },
    focus: {
      typography: VIOLET[12],
      border: VIOLET[12],
      background: 'transparent'
    },
    active: {
      typography: VIOLET[11],
      border: VIOLET[11],
      background: 'transparent'
    },
    disabled: {
      typography: VIOLET[15],
      border: VIOLET[15],
      background: 'transparent'
    }
  }
};
export default {
  contained: Contained,
  outlined: OutlinedAndText,
  text: OutlinedAndText
};